"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.array.iterator.js");
require("core-js/modules/web.dom.iterable.js");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("./constants");
var _Dropdown = _interopRequireDefault(require("./Dropdown"));
var _ThemeContext = _interopRequireDefault(require("./ThemeContext"));
var _jsxFileName = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/ThemeSelector.js",
  _templateObject,
  _templateObject2;
function cov_1cjikkfx3v() {
  var path = "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/ThemeSelector.js";
  var hash = "2d35b8503304f668ed67af100ff24bda42946bf0";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src190565674/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/helpers/ThemeProvider/lib/ThemeSelector.js",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 22
        },
        end: {
          line: 9,
          column: 96
        }
      },
      "1": {
        start: {
          line: 9,
          column: 78
        },
        end: {
          line: 9,
          column: 94
        }
      },
      "2": {
        start: {
          line: 11,
          column: 31
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "3": {
        start: {
          line: 19,
          column: 26
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "4": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 17
        }
      },
      "5": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 40
        }
      },
      "6": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 61
        }
      },
      "7": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 35,
          column: 55
        }
      },
      "8": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "9": {
        start: {
          line: 43,
          column: 22
        },
        end: {
          line: 43,
          column: 32
        }
      },
      "10": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 47,
          column: 6
        }
      },
      "11": {
        start: {
          line: 51,
          column: 34
        },
        end: {
          line: 51,
          column: 44
        }
      },
      "12": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 68,
          column: 6
        }
      },
      "13": {
        start: {
          line: 72,
          column: 0
        },
        end: {
          line: 76,
          column: 2
        }
      },
      "14": {
        start: {
          line: 78,
          column: 0
        },
        end: {
          line: 82,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 57
          },
          end: {
            line: 9,
            column: 58
          }
        },
        loc: {
          start: {
            line: 9,
            column: 78
          },
          end: {
            line: 9,
            column: 94
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 21
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 34
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 21
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 42
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 50,
            column: 3
          }
        },
        loc: {
          start: {
            line: 50,
            column: 11
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 50
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 56,
            column: 11
          },
          end: {
            line: 64,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 56,
            column: 11
          },
          end: {
            line: 56,
            column: 18
          }
        }, {
          start: {
            line: 57,
            column: 12
          },
          end: {
            line: 63,
            column: 32
          }
        }],
        line: 56
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "2d35b8503304f668ed67af100ff24bda42946bf0"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1cjikkfx3v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1cjikkfx3v();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var THEME_OPTIONS = (cov_1cjikkfx3v().s[0]++, (0, _lodash.entries)(_constants.TicketShopThemeLabel).map(function (_ref) {
  var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
    value = _ref2[0],
    label = _ref2[1];
  cov_1cjikkfx3v().f[0]++;
  cov_1cjikkfx3v().s[1]++;
  return {
    label: label,
    value: value
  };
}));
var ThemeSelectorContainer = (cov_1cjikkfx3v().s[2]++, _styledComponents.default.div.attrs({
  className: 'stx-ThemeSelector-Container'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  height: 100%;\n  position: relative;\n"]))));
var DropdownContainer = (cov_1cjikkfx3v().s[3]++, _styledComponents.default.div.attrs({
  className: 'stx-ThemeSelector-MultiDropdown-Container'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 9999;\n"]))));
var ThemeSelector = /*#__PURE__*/function (_React$Component) {
  function ThemeSelector(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ThemeSelector);
    cov_1cjikkfx3v().f[1]++;
    cov_1cjikkfx3v().s[4]++;
    _this = _callSuper(this, ThemeSelector, [props]);
    cov_1cjikkfx3v().s[5]++;
    _this.state = {
      theme: props.theme
    };
    cov_1cjikkfx3v().s[6]++;
    _this.getSelectedValue = _this.getSelectedValue.bind(_this);
    cov_1cjikkfx3v().s[7]++;
    _this.onSelectTheme = _this.onSelectTheme.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(ThemeSelector, _React$Component);
  return (0, _createClass2.default)(ThemeSelector, [{
    key: "onSelectTheme",
    value: function onSelectTheme(_ref3) {
      var theme = _ref3.value;
      cov_1cjikkfx3v().f[2]++;
      cov_1cjikkfx3v().s[8]++;
      this.setState({
        theme: theme
      });
    }
  }, {
    key: "getSelectedValue",
    value: function getSelectedValue() {
      cov_1cjikkfx3v().f[3]++;
      var _ref4 = (cov_1cjikkfx3v().s[9]++, this.state),
        theme = _ref4.theme;
      cov_1cjikkfx3v().s[10]++;
      return {
        value: theme,
        label: _constants.TicketShopThemeLabel[theme]
      };
    }
  }, {
    key: "render",
    value: function render() {
      cov_1cjikkfx3v().f[4]++;
      var _ref5 = (cov_1cjikkfx3v().s[11]++, this.props),
        devMode = _ref5.devMode,
        children = _ref5.children;
      cov_1cjikkfx3v().s[12]++;
      return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
        value: {
          theme: this.state.theme,
          variables: _constants.TicketShopThemeVariables[this.state.theme]
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 53,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(ThemeSelectorContainer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 55,
          columnNumber: 9
        }
      }, (cov_1cjikkfx3v().b[0][0]++, devMode) && (cov_1cjikkfx3v().b[0][1]++, /*#__PURE__*/_react.default.createElement(DropdownContainer, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
        value: this.getSelectedValue(),
        options: THEME_OPTIONS,
        onChange: this.onSelectTheme,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 15
        }
      }))), children));
    }
  }]);
}((_react.default.Component));
cov_1cjikkfx3v().s[13]++;
ThemeSelector.propTypes = {
  theme: _propTypes.default.oneOf((0, _lodash.values)(_constants.TicketShopTheme)),
  children: _propTypes.default.element,
  devMode: _propTypes.default.bool
};
cov_1cjikkfx3v().s[14]++;
ThemeSelector.defaultProps = {
  theme: _constants.TicketShopTheme.EQUILIBRIUM,
  children: null,
  devMode: false
};
var _default = exports.default = ThemeSelector;